import { createContext, useRef, useState } from "react";
import reqFornecedor from "../../../../services/reqMultiTenant/reqFornecedor";

const ContextRegisterSupplier = createContext({});

function RegisterSupplierProvider(props) {
	// Controle Modal
	const [isOpenModalFilterSupplier, setIsOpenModalFilterSupplier] = useState(false);
	const [isOpenModalRegisterSupplier, setIsOpenModalRegisterSupplier] = useState(false);

	//Dados do fornecedor
	const [id_fornecedor, setId_Fornecedor] = useState(0);
	const [supplierData, setSupplierData] = useState([]);
	const [filterData, setFilterData] = useState({});

	//Controle de paginação
	const [page, setPage] = useState(1);
	const [totalPage, setTotalPage] = useState(0);
	const currentPage = useRef(0);

	const [loading, setLoading] = useState(false);

	const openModalFilterSupplier = () => {
		setIsOpenModalFilterSupplier((prevState) => !prevState);
	};

	const openModalRegisterSupplier = (item) => {
		let id = 0;

		if (item?.id_fornecedor) id = item.id_fornecedor;

		setId_Fornecedor(id);

		setIsOpenModalRegisterSupplier(true);
	};

	// busca o resultado completo da pesquisa (mesmos filtros), sem paginação, usado para gerar o relatório
	const fetchAllSuppliers = async () => {
		const { param, paramValue, ativo } = filterData;

		const response = await reqFornecedor.listPaginate(param, paramValue, ativo, 1, 100000);
		return response?.data || [];
	};

	const fetchSupplierPaginate = async () => {
		setLoading(true);
		try {
			try {
				const { param, paramValue, active } = filterData;

				let ativo = "NAO";
				if (active === true) ativo = "SIM";

				const responseSupplier = await reqFornecedor.listPaginate(
					param,
					paramValue,
					ativo,
					currentPage.current + 1
				);

				// const recordCount = responseSupplier.data.length;
				setSupplierData((prevDate) => [...prevDate, ...responseSupplier.data]);

				//se não encontrou nada esta na ultima pagina
				if (responseSupplier.data.length < 15) {
					setTotalPage(currentPage.current + 1);
				}

				if (responseSupplier.data.length !== 0) currentPage.current++;
			} catch (error) {
				setSupplierData([]);
			}
		} finally {
			setLoading(false);
		}
	};

	const closeModalRegisterSupplier = () => {
		setIsOpenModalRegisterSupplier(false);
	};

	return (
		<ContextRegisterSupplier.Provider
			value={{
				isOpenModalFilterSupplier,
				isOpenModalRegisterSupplier,
				id_fornecedor,
				openModalRegisterSupplier,
				closeModalRegisterSupplier,
				openModalFilterSupplier,
				setSupplierData,
				setFilterData,
				fetchSupplierPaginate,
				fetchAllSuppliers,
				filterData,
				supplierData,
				page,
				totalPage,
				loading,
				setPage,
				setTotalPage,
				setLoading,
				currentPage,
			}}
		>
			{props.children}
		</ContextRegisterSupplier.Provider>
	);
}

export { ContextRegisterSupplier, RegisterSupplierProvider };
